import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CartItem } from "../../../models/cart_item.model";
import { CartItemService } from "../../../services/cart_item.service";
import { CartObserver } from "../../../observers/cart.observer";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { FormControl } from "@angular/forms";
import { LanguageService } from "../../../services/language.service";
import { CurrencyObserver } from "../../../observers/currency.observer";
import { Voucher } from "../../../models/voucher.model";
import { BookPriceOffer } from "../../../models/vouchers/book_price_offer.model";
import { CartService } from "../../../services/cart.service";

@Component({
  selector: 'app-book-launch-offer-item',
  templateUrl: './book-launch-offer-item.component.html',
  styleUrls: ['./book-launch-offer-item.component.scss']
})
export class BookLaunchOfferItemComponent implements OnInit {

  @Input() tier: BookPriceOffer | undefined
  @Input() disabled: boolean = false
  @Output() selectTier: EventEmitter<BookPriceOffer> = new EventEmitter<BookPriceOffer>()

  constructor(
    private cartObserver: CartObserver,
    public currencyObserver: CurrencyObserver,
    private cartService: CartService
  ) {
  }

  ngOnInit(): void {
  }

  addToCart() {
    if (this.disabled) {
      return
    }

    if (this.tier) {
      this.cartService.addBundleOfferToCart(this.tier).subscribe(
        (cart) => this.cartObserver.updateCartItemCount(cart)
      )
    }
  }

  chooseTier() {
    this.selectTier.emit(this.tier)
  }

}
